import { memo } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import TaskInfoPanel from "@coworker/apprestructured/src/task-management/components/TaskInfoPanel/TaskInfoPanel";
import TaskInfoModal from "@coworker/apprestructured/src/task-management/components/TaskInfoPanel/TaskInfoModal/TaskInfoModal";
import MfaqFollowUpGraph from "@coworker/apprestructured/src/task-management/components/TaskInfoPanel/TaskInfoModal/MfaqFollowUpGraph";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";

function TaskInfoPanelDemo() {
  return (
    <Demo>
      <Name>TaskInfoPanel</Name>
      <Highlight>
        <TaskInfoPanel
          label="Upvotes"
          sublabel=" - Last 4 weeks"
          value={562}
          caption="in Home Service Point - Planning studio"
          infoButtonAriaLabel="About MFAQ"
          infoContent={({ visible, onClose }) => (
            <TaskInfoModal
              visible={visible}
              onClose={onClose}
              title="About MFAQ"
              heading="MFAQ Follow-up task"
              description={
                "This task is created based on the most frequently asked questions by customers.\nUse it to improve the shopping experience by addressing common concerns."
              }
              illustration={<MfaqFollowUpGraph />}
            />
          )}
        />
      </Highlight>
    </Demo>
  );
}

export default memo(TaskInfoPanelDemo);
